<template>
  <div class="bread">
      <div class="container">
          <div class="text">
              <a href="http://www.cnzyjy.org.cn/">首页</a>&nbsp;&gt;&nbsp;<router-link :to="`${location.link}`">{{ location.name }}</router-link
    >&nbsp;&gt;&nbsp;<a href="javascript:;" v-if="location.type == 'info'">{{location.xname?location.xname:'正文'}}</a>
          </div>
      </div>
  </div>
</template>

<script>
export default {
  props: {
    location: Object,
  },
};
</script>
<style scoped>
</style>